var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-radius":"50px"}},[_c('prism',{staticStyle:{"heigth":"150px"},attrs:{"language":_vm.language,"code":_vm.code}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }